// src/pages/ResetPasswordPage.jsx (or your file name)
import React, { useState } from "react";
import { Box, Paper, Typography, Button, CssBaseline } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import sidebarlogo from "../../assets/images/logo/Budgie_Logo.png";
import FormikTextInput from "@/components/forms/FormikTextInput";
import FormikEmailInput from "@/components/forms/FormikEmailInput";
import FormikPasswordInput from "@/components/forms/FormikPasswordInput";
import { useUpdatePasswordMutation } from "@/api/services/changePassword/changePassword";
import { useResetPasswordMutation } from "@/api/services/auth/login/LoginApi";
import Loader from "@/components/loader";
import { toast } from "@/components/toastify";
import SubmitButtonWithLoader from "@/components/forms/SubmitButtonWithLoader";
import { Navigate, useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [updatePassword] = useUpdatePasswordMutation();
  const [resetPassword, { isLoading: loading }] = useResetPasswordMutation();
  const hash = window.location.hash;
  const token = hash.split("token=")[1]?.split("&")[0];

  console.log("Token:", token);

  const handleSubmit = async (values, resetForm) => {
    console.log("Submitting...", values);
    const data = {
      token: token,
      confirmPassword: values.confirmPassword,
    };

    try {
      const res = await resetPassword(data).unwrap();

      if (res) {
        toast("success", "Password updated successfully");
        navigate("/login");
        // resetForm();
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      // toast("error", "Failed to update password");
      // navigate("/login");
    } finally {
    }
  };
  // --- TODO: Add your API call logic here ---
  // The `values.email` will be whatever value is in Formik's state,
  // even though the field was disabled.

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .max(16, "Password must not exceed 16 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&#]/,
        "Password must contain at least one special character",
      )
      .required("Password is required"),

    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords must match")
      .required("Please confirm your password"),
  });

  // --- Validation Schema (Stays the same) ---
  const ResetPasswordSchema = Yup.object().shape({
    employeeId: Yup.string().required("Employee ID is required"),
    email: Yup.string() // Still required by Yup
      .email("Invalid email address")
      .required("Email is required"), // This rule remains active
  });

  // --- Initial Form Values ---
  // IMPORTANT: If the email is disabled, it usually means its value
  // should be pre-filled from somewhere else (e.g., user data).
  // If it starts empty and is disabled, the validation will always fail.
  const initialValues = {
    employeeId: "",
    // Example: Pre-fill the email if it's known and shouldn't be changed
    // email: 'user.email@example.com',
    email: "", // Or leave empty if it should fail validation initially
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          bgcolor: "#f7f8fc",
        }}
      >
        {/* Logo Placeholder */}
        <Box sx={{ mb: 4 }}>
          <img
            src={sidebarlogo}
            alt="Sidebar Logo"
            style={{ height: "78px", width: "86px" }}
          />
        </Box>

        <Paper
          elevation={3}
          sx={{
            p: { xs: 2, sm: 4 },
            borderRadius: 2,
            width: "100%",
            maxWidth: "450px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            Reset Your Password
          </Typography>

          <Formik
            initialValues={{
              newPassword: "",
              confirmPassword: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelpers) => {
              handleSubmit(values, formikHelpers.resetForm);
              console.log("Submitted values:", values);
            }}
            enableReinitialize
          >
            {() => (
              <>
                {/* {loading && (
                  <Box
                    sx={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      zIndex: 1300,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Loader />
                  </Box>
                )} */}
                <Form>
                  <FormikPasswordInput
                    name="newPassword"
                    label="New Password"
                    placeholder="Enter your New Password"
                    required
                  />
                  <FormikPasswordInput
                    name="confirmPassword"
                    label="Confirm Password"
                    placeholder="Enter your Confirm password"
                    required
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <SubmitButtonWithLoader
                      type="submit"
                      variant="contained"
                      loading={loading}
                    >
                      Submit
                    </SubmitButtonWithLoader>
                  </Box>
                  {/* <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: "#2B5F40",
                      color: "#FFFFFF",
                      fontFamily: "Lato, sans-serif",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "24px",
                      padding: "6px 16px",
                      borderRadius: "4px",
                      minWidth: "80px",
                      textTransform: "none",
                      marginLeft: "8px",
                      "&:hover": {
                        backgroundColor: "#1A3D29",
                      },
                    }}
                    onSubmit={() => resetForm()}
                  >
                    Submit
                  </Button> */}
                </Form>
              </>
            )}
          </Formik>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default ForgotPassword;
